import React from 'react';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Footer from 'layout/Footer';
import 'assets/animation/portalAnimation';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Home from './Home/Home';
import AboutUsContainer from './AboutUs/AboutUsContainer';
import PracticeWithUsContainer from './PracticeWithUs/PracticeWithUsContainer';
import AccessService from './AccessService/AccessService';
import News from './News/News';
import FAQForm from './FAQ/FAQForm';
import { useHistory, useLocation } from 'react-router-dom';

gsap.registerPlugin(ScrollTrigger);

const addScrollClass = () => {
    if (window.scrollY > 40) {
        document.body.classList.add('page-scrolled');
    } else {
        document.body.classList.remove('page-scrolled');
    }
};

window.addEventListener('scroll', addScrollClass);

const HEADER_PADDING_EXPANDED = 18;
const HEADER_PADDING_SHRUNK = 6;
const HEADER_SHRINK_SCROLL_Y = 40;

const Landing: React.FC = () => {
    const location = useLocation<{ id?: string; fromDrawer?: boolean }>();
    const history = useHistory();

    const getHeaderHeight = (willShrink: boolean) => {
        const header = document.querySelector('.header') as HTMLElement | null;
        if (!header) return 80;

        const height = header.offsetHeight;

        // total vertical padding difference = (18 + 18) - (6 + 6) = 24px
        const paddingDiff = (HEADER_PADDING_EXPANDED - HEADER_PADDING_SHRUNK) * 2;

        return willShrink ? height - paddingDiff : height;
    };

    React.useEffect(() => {
        // To not auto scroll from history
        if ('scrollRestoration' in window.history) {
            window.history.scrollRestoration = 'manual';
        }
        // When came from clinicians page, this will be executed
        if (location.state?.id) {
            const target = document.getElementById(location.state.id);
            const fromDrawer = location.state?.fromDrawer;
            if (target) {
                setTimeout(() => {
                    const sectionTop = target.getBoundingClientRect().top + window.scrollY;

                    // Predict scroll position to check if header will shrink
                    const willShrink = sectionTop > HEADER_SHRINK_SCROLL_Y;
                    const headerHeight = getHeaderHeight(willShrink && !fromDrawer);
                    const finalTop = sectionTop - headerHeight;

                    window.scrollTo({
                        top: finalTop,
                        behavior: 'smooth',
                    });
                    history.replace({ ...location, state: {} });
                }, 500);
            }
        } else {
            window.scrollTo({ top: 0, behavior: 'instant' });
        }
    }, []);

    return (
        <div className="wrapper">
            <div className="main-content">
                <Home />
                <AboutUsContainer />
                <PracticeWithUsContainer />
                <AccessService />
                <News />
                <FAQForm />
            </div>
            <Footer />
        </div>
    );
};

export default Landing;
